import { render, staticRenderFns } from "./SimpleModal.vue?vue&type=template&id=a9013472"
import script from "./SimpleModal.vue?vue&type=script&lang=js"
export * from "./SimpleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports